module.exports = {
	RECEIVE_PIEZOMETER: 'RECEIVE_PIEZOMETER',
	RECEIVE_QUALITOMETER: 'RECEIVE_QUALITOMETER',
	RECEIVE_SURFACE_QUALITOMETER: 'RECEIVE_SURFACE_QUALITOMETER',
	RECEIVE_POLLUTED_SOIL: 'RECEIVE_POLLUTED_SOIL',
	RECEIVE_INDUSTRIAL_SITE: 'RECEIVE_INDUSTRIAL_SITE',
	ADD_PIEZOMETER_MEASURE: 'ADD_PIEZOMETER_MEASURE',
	ADD_PICKUP_OPERATION: 'ADD_PICKUP_OPERATION',
	ADD_QUALITOMETER_ANALYSIS: 'ADD_QUALITOMETER_ANALYSIS',
	ADD_CITIES: 'ADD_CITIES',
	ADD_PIEZOMETER_KEY_FIGURE: 'ADD_PIEZOMETER_KEY_FIGURE',
	ADD_QUALITOMETER_KEY_FIGURE: 'ADD_QUALITOMETER_KEY_FIGURE',
	RESET_USER_STATION: 'RESET_USER_STATION'
}



// WEBPACK FOOTER //
// ./src/dashboard/constants/DashboardConstants.js